/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {SpGridComponent as Éµa} from './src/app/modules/sp-grid/sp-grid.component';